import {Injectable, OnInit} from '@angular/core';
import {forkJoin, from, Observable} from "rxjs";
import '../../../configs/baby_style_bg.ts';
import '../../../configs/label_styles_config.ts';
import {fromArray} from "rxjs/internal/observable/fromArray";
import {pipeFromArray} from "rxjs/internal/util/pipe";
import {debounceTime, flatMap, mergeMap} from "rxjs/operators";
import {CesiumAdapterService} from "../cesiumAdapter21/cesium-adapter.service";

@Injectable({
  providedIn: 'root'
})
export class LabelStyleProviderService{
  list;
  // LABEL_STYLES;
  babyStyleBg;
  isImg;
  isLoaded = false;

  constructor(private view: CesiumAdapterService) {
  }

  isBackgroundImg() {
    return this.babyStyleBg.indexOf('http')>=0;
  }

  private getBabyStyleBg(){
    return new Observable<any>(observer => {
      observer.next(window['BABY_STYLE_BG']);
    });
  }

  private getLabelStyles(){
    return new Observable<any>(observer => {
      observer.next(window['LABEL_STYLES']);
    });
  }

  private loadLists(){
    let self = this;
    return new Observable(observer =>{
      if (!this.isLoaded){
        this.getBabyStyleBg().pipe(
          flatMap(result => {
            self.babyStyleBg = result;
            self.isImg = self.isBackgroundImg();
            return self.getLabelStyles();
          })
        ).subscribe((result)=>{
          self.isLoaded = true;
          self.list = result;
          observer.next(true);
        });
      }
      else{
        observer.next(true);
      }
    })
  }

  private prepareList(){
    return new Observable((observer)=>{
      this.loadLists().subscribe((status)=>{
        if (status){
          for (var style in this.list){
            if (this.list.hasOwnProperty(style)){
              var curStyle = this.list[style];
              if (!curStyle.hasOwnProperty('backgroundColor') && !curStyle.hasOwnProperty('background') && !curStyle.hasOwnProperty('backgroundImage')){
                (this.isImg) ? curStyle['background-image'] = 'url('+this.babyStyleBg+')' : curStyle.backgroundColor = this.babyStyleBg;
              }
            }
          }
        }
        observer.next(true);
        observer.complete();
      })
    })
  }

  public getAll () {
    let self = this;
    return new Promise((resolve)=>{
      this.prepareList().subscribe((result)=>{
        if (result) resolve(self.list);
      })
    })
  }

  public getZoomStyleByKey(name){
    let self = this;
    return new Observable((observer)=>{
      let _name = name || Object.keys(self.list)[0];
      this.prepareList().subscribe((result)=>{
        if (result){
          this.view.zoom.pipe(debounceTime(200)).subscribe((zoomLevel)=>{
            let prepareStyles;
            if (Array.isArray(self.list[_name])){
              for (let i = 0; i< self.list[_name].length; i++){
                let zoomStyleConfig = self.list[_name][i];
                if (zoomLevel <= zoomStyleConfig.max && zoomLevel >= zoomStyleConfig.min){
                  prepareStyles = zoomStyleConfig.css;
                  break;
                }
              }
            }
            else{
              if (!_name){
                observer.error('zoom style key is null');
                observer.complete();
                return;
              }
              prepareStyles = _name.trim().length>0 ? self.list[_name] : self.list[Object.keys(self.list)[0]];
            }
            observer.next(prepareStyles);
            observer.complete();
          })
        }
      })
    })
  }
}
